<template>
  <router-view />
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
